const searchPopUpInit = () => {
  const closeButton = document.querySelector('.search-popup__close') as HTMLElement;
  const searchPopUp = document.querySelector('.search-popup') as HTMLElement;
  const searchPopUpBG = document.querySelector('.search-popup__bg') as HTMLElement;
  const searchButton = document.querySelector('.header__search') as HTMLElement;

  closeButton.addEventListener('click', () => {
    searchPopUp.classList.add('d-none');
  });
  searchPopUpBG.addEventListener('click', () => {
    searchPopUp.classList.add('d-none');
  });
  searchButton.addEventListener('click', () => {
    searchPopUp.classList.remove('d-none');
  });
};

export default searchPopUpInit;
